import { Currency } from "./localization/currency";

export type FormRequestType = "RAQ" | "RAB" | "RAC" | "SFO" | "EMA" | "";

export interface LeadAPIRequest {
  ID?: number;
  Title?: string;
  NameFirst?: string;
  NameMiddle?: string;
  NameLast?: string;
  Email?: string;
  Phone?: string;
  Address1?: string;
  Address2?: string;
  City?: string;
  State?: string;
  //  County?: string;
  Zip?: string;
  Zip4?: string;
  Country?: string;
  PreferredDestinations?: string;
  VSNumber?: string;
  BookingNumber?: string;
  WorkingWithAgent?: 0 | 1;
  IsAgent?: 0 | 1;
  BrochuresRequested?: string;
  SiteCurrency?: Currency;
  SiteLanguage?: string;
  VoyageCod?: string;
  Voyage?: string;
  Ship?: string;
  SailDate?: Date;
  Comments?: string;
  RequestDate?: Date;
  RequestType?: FormRequestType;
  RequestSubType?: string;
  RequestSource?: string;
  InsertUTCDate?: Date;
  DeparturePort?: string;
  ArrivalPort?: string;
  Completed?: 0 | 1;
  MarketingEffort?: string;
  MCId?: string;
  SubscribeEmail?: "true" | "false";
  SuiteCategory?: string;
  SuiteVariation?: string;
  Price?: number;
  SiteCountry?: string;
  Att01?: string;
  Att02?: string;
  Att03?: string;
  Att04?: string;
  Att05?: string;
  Att06?: string;
  Att07?: string;
  Att08?: string;
  Att09?: string;
  Att10?: string;
  AUID?: string;
}

class LeadAPIInvalidEmailError extends Error {
  constructor(message?: string) {
    super(message); // 'Error' breaks prototype chain here
    this.name = "LeadAPIInvalidEmailError";
    Object.setPrototypeOf(this, new.target.prototype); // restore prototype chain
  }
}

export { LeadAPIInvalidEmailError };

export async function sendLead(
  data: LeadAPIRequest,
  baseUrl = process.env.GATSBY_DIGITAL_API_BASE_URL || ""
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<any> {
  const response = await fetch(`${baseUrl}/leadApiSubmission`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(data)
  });

  const jsonResponse = await response.json();

  if (response.status == 201) return jsonResponse;

  if (response.status == 422) {
    if (jsonResponse.field == "Email")
      throw new LeadAPIInvalidEmailError("Email not valid");
  }

  throw new Error(jsonResponse.message);
}
